import type { ReactNativeOptions } from '@sentry/react-native';

import { CLIENT_APP, getClientIdentity } from '@/utils/clientIdentity';

/**
 * The web build has no native SDK to derive a release from, so it is named
 * here: app, version and the deployed commit (`EXPO_PUBLIC_GIT_SHA`).
 */
const getWebRelease = () => {
  const version = getClientIdentity().version ?? '0.0.0';
  const sha = process.env.EXPO_PUBLIC_GIT_SHA?.slice(0, 7);
  return `${CLIENT_APP}-web@${version}${sha ? `+${sha}` : ''}`;
};

/**
 * Errors thrown by scripts that in-app browsers (Instagram, Facebook) inject
 * to reach their native bridges. They are not the app's code.
 */
const IN_APP_BROWSER_BRIDGE_ERRORS = [
  /Java object is gone/,
  /window\.webkit\.messageHandlers/,
];

export const getPlatformSentryOptions = (
  environment: string,
): Partial<ReactNativeOptions> => ({
  environment,
  release: getWebRelease(),
  ignoreErrors: IN_APP_BROWSER_BRIDGE_ERRORS,
  beforeSend: (event) => {
    if (event.contexts?.ota_updates) {
      const { ota_updates: _otaUpdates, ...contexts } = event.contexts;
      return { ...event, contexts };
    }
    return event;
  },
});
